<template>
  <div>
    <el-dialog
      :visible="showRegister"
      :before-close="registerClose"
      :close-on-click-modal="false"
      top="32px"
      class="regiter-dialog"
    >
      <div class="dialog-header">
        <i class="logo-icon" />
        <h3 class="text-center is-bold">会员注册</h3>
      </div>
      <el-form
        ref="registerForm"
        :model="registerForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item
          label="用户名"
          prop="userName"
        >
          <el-input
            v-model="registerForm.userName"
            placeholder="请输入用户名"
          />
        </el-form-item>
        <el-form-item
          label="密码"
          prop="password"
        >
          <el-input
            v-model="registerForm.password"
            type="password"
            placeholder="请输入6-12位密码，须由英文和数字符号组成"
          />
        </el-form-item>
        <el-form-item
          label="确认密码"
          prop="repassword"
        >
          <el-input
            v-model="registerForm.repassword"
            type="password"
            placeholder="请再次输入密码"
          />
        </el-form-item>
        <el-form-item
          label="邮箱"
          prop="email"
        >
          <el-input
            v-model="registerForm.email"
            placeholder="请输入常用邮箱"
          />
        </el-form-item>
        <el-form-item
          label="验证码"
          prop="validCode"
        >
          <el-input
            v-model="registerForm.validCode"
            class="valid-code-input"
            placeholder="请输入验证码"
          />
          <el-button
            :loading="validCodeLoading"
            :disabled="codeTime!==0"
            class="code-btn"
            @click="getValidCode"
          >{{ codeTime ? codeTime + '秒后重新获取' : '获取验证码' }}</el-button>
        </el-form-item>
        <el-form-item
          label="真实姓名"
          prop="realName"
        >
          <el-input v-model="registerForm.realName" />
        </el-form-item>
        <el-form-item
          label="单位名称"
          prop="companyName"
        >
          <el-input v-model="registerForm.companyName" />
        </el-form-item>
        <el-form-item
          label="联系电话"
          prop="telPhone"
        >
          <el-input v-model="registerForm.telPhone" />
        </el-form-item>
        <el-form-item class="operate-item">
          <el-button
            :disabled="registerLoading"
            class="register-btn"
            @click="register"
          >注册</el-button>
        </el-form-item>
        <el-form-item class="operate-item tips-item">
          <span class="tip-text">已有帐号？</span>
          <a
            class="operate-color pointer"
            @click="tologin"
          >立即登录</a>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      :visible.sync="successShow"
      class="register-success-dialog"
    >
      <i class="el-icon-circle-check" />
      <div class="text-center message margin-bottom30">恭喜您，注册成功!</div>
      <div class="text-center operate">
        <a
          class="pointer"
          @click="tologin"
        >立即登录</a>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex'
import {formValidate} from '@/service/formValidate'
import {userService} from '@/service/httpService'

export default {
  data () {
    let me = this
    return {
      registerForm: {},
      rules: {
        userName: [
           { validator: me.validateUser, trigger: 'blur', required: true }
        ],
        password: [
          { validator: formValidate.validatePwd, trigger: 'change', required: true }
        ],
        repassword: [
          {
            validator (rule, val, cb) {
              formValidate.validatePwdRepeat(me.registerForm.password, val, cb)
            },
            trigger: 'change',
            required: true
          }
        ],
        email: [
          { validator: formValidate.validateEmail, trigger: 'change', required: true }
        ],
        validCode: [
          {
            validator (rule, val, cb) {
              formValidate.validateNotNull(val, '验证码不能为空', cb)
            },
            trigger: 'blur',
            required: true
          }
        ],
        realName: [
          {
            validator (rule, val, cb) {
              formValidate.validateNotNull(val, '真实姓名不能为空', cb)
            },
            trigger: 'blur',
            required: true
          },
          {
            validator (rule, val, cb) {
              formValidate.validateMaxLength(val, 100, '最大输入长度不能超过100', cb)
            },
            trigger: 'change'
          }
        ],
        companyName: [
          {
            validator (rule, val, cb) {
              formValidate.validateNotNull(val, '公司名称不能为空', cb)
            },
            trigger: 'blur',
            required: true
          },
          {
            validator (rule, val, cb) {
              formValidate.validateMaxLength(val, 100, '最大输入长度不能超过100', cb)
            },
            trigger: 'change'
          }
        ],
        telPhone: [
          { validator: formValidate.validatePhone, trigger: 'change', required: true }
        ]
      },

      // 注册成功弹框
      successShow: false,
      codeTime: 0,
      validCodeLoading: false,
      registerLoading: false
    }
  },
  computed: {
    ...mapState({
      showRegister: 'showRegister'
    })
  },
  watch: {
    showRegister (val) {
      if (val) {
        this.initForm()
      }
    }
  },
  created () {
    this.initForm()
  },
  methods: {
    ...mapMutations({
      'registerClose': 'REGISTER_CLOSE',
      'loginShow': 'LOGIN_SHOW'
    }),

    initForm () {
      this.registerForm = {
        userName: '',
        password: '',
        repassword: '',
        email: '',
        validCode: '',
        realName: '',
        companyName: '',
        telPhone: ''
      }
    },

    // 注册
    register () {
      this.$refs.registerForm.validate((valid) => {
        if (!valid) {
          return false
        }

        this.registerLoading = true
        let param = {
          Name: this.registerForm.userName,
          TrueName: this.registerForm.realName,
          Email: this.registerForm.email,
          Password: this.registerForm.password,
          Employer: this.registerForm.companyName,
          Phone: this.registerForm.telPhone
        }
        let queryParam = {
          code: this.registerForm.validCode
        }
        userService.register(param, queryParam).then(res => {
          this.registerLoading = false
          this.registerClose()
          this.successShow = true
        })
        .catch((err) => {
          let message = err.data.message
          if (message) {
            message = message.split('--')
          }
          this.registerLoading = false
          this.$message({type: 'error', message: message[1] || '注册失败'})
        })
      })
    },

    // 登录
    tologin () {
      this.successShow = false
      this.registerClose()
      this.loginShow()
    },

    // 表单校验相关方法
    validateUser (rule, value, callback) {
      if (!value.replace(/\s/g, '')) {
        return callback(new Error('姓名不能为空'))
      }
      // 获取接口校验是否存在的用户名
      userService.checkUser({username: value}).then(() => {
        callback()
      }).catch(err => {
        if (err.response && err.response.data) {
          callback(new Error(err.response.data.Message))
        } else {
          callback(new Error('请求错误，错误代码：' + err.status))
        }
      })
    },

    validateTimer () {
      let timer = null
      this.codeTime = 60
      timer = window.setInterval(() => {
        if (this.codeTime === 1) {
          clearInterval(timer)
        }
        this.codeTime--
      }, 1000)
    },

    // 获取验证码
    getValidCode () {
      this.$refs.registerForm.validateField('email', errorMessage => {
        if (errorMessage) {
          this.$message({type: 'error', message: errorMessage})
          return false
        }
        let param = {
          email: this.registerForm.email
        }

        this.validCodeLoading = true
        userService.registerCode(param).then(res => {
          this.validCodeLoading = false
          this.$message({type: 'success', message: '已将验证码发送至邮箱'})
          this.validateTimer()
        })
        .catch((err) => {
          this.validCodeLoading = false
          let message = err.data.message
          if (message) {
            message = message.split('--')
          }
          this.$message({type: 'error', message: message[1] || '发送验证码失败'})
        })
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/modules/common/user-out/register.vue